import { Navigate, type RouteObject } from 'react-router-dom';

import { LegalRootLayout } from './LegalRootLayout';

export const legalRoutes: RouteObject = {
  path: 'legal',
  element: <LegalRootLayout />,
  children: [
    // { index: true, element: <Navigate to="" replace /> },
    {
      path: '',
      children: [
        { index: true, element: <Navigate to="agreement" replace /> },
        {
          path: 'agreement',
          lazy: () => import('../../app/legal/Agreement'),
        },
        {
          path: 'terms-of-use',
          lazy: () => import('../../app/legal/TermsOfUse'),
        },
        {
          path: 'about-us',
          lazy: () => import('../../app/legal/AboutUs'),
        },
        {
          path: 'privacy-policy',
          lazy: () => import('../../app/legal/PrivacyPolicy'),
        },
        {
          path: 'distance-sales-contract',
          lazy: () => import('../../app/legal/DistanceSalesContract'),
        },
        {
          path: 'delivery-and-return-policy',
          lazy: () => import('../../app/legal/DeliveryAndReturnPolicy'),
        },
      ],
    },
  ],
};
